import React from 'react';
import './homepage.css';
import HomepageBanner from '../../components/homepage-banner/homepageBanner.jsx'
import Portfolio from '../../components/project-portfolio/portfolio.js';
import Clients from '../../components/clients/clients.js'
import JobCount from '../../components/job-count/job-count.js';
import mainImage from './assets/2024-0606-image-placeholder1.jpg'




function Homepage() {

    return (

        <div className='pageWrapper'>

            <HomepageBanner
                heading="Quality Construction In The Heart Of Ohio"
                bannerImage={mainImage}
                altText='Brocon Project Sequoia'
            />

            <div className='homepageContent'>
                <div className='innerHomepageWrapper'>
                    <div className='contentSection'>
                        <h2>Quailty Is Our Business</h2>
                        <p> Founded in 1988, Brocon Construction, Inc. has built a strong reputation
                            as a trusted leader in the Columbus construction industry. We began as
                            a subcontractor specializing in metal stud framing, drywall, and
                            acoustic ceilings, known for our commitment to quality and reliability.
                            <br></br>
                            <br></br>
                            Over the years, that dedication fueled our evolution into a full-service
                            general contractor and owner’s representative. By 2003, Brocon had
                            expanded its reach by providing project management and general
                            supervision across a wide range of commercial and industrial projects.
                            <br></br>
                        </p>
                        <a className='textLink' href='/about-us'>More About Us &rarr;</a>
                    </div>
                    <div className='contentSectionPortfolio' id='portfolio'>
                        <div className='altContentWrapper'>
                            <h3>Recent Projects</h3>
                            <Portfolio />
                        </div>
                    </div>
                    < JobCount />
                    <div className='contentSection' id='clients'>
                        <div className='altContentWrapper'>
                            <h2>Our clients</h2>
                        </div>
                    </div>
                </div>
                <Clients />
                <div className='innerHomepageWrapper'>

                </div>
            </div>
        </div>
    );
}

export default Homepage;